import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_LAPORAN, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_LAPORAN = 'GET_LIST_LAPORAN';

export const getLaporan = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_LAPORAN);

    axios({
      method: 'get',
      url: GET_LAPORAN,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_LAPORAN, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_LAPORAN,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_LAPORAN, error);
        alert(error);
      });
  };
};
